import styled from "styled-components";


const StyledButton = styled.button`
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.2s;
  font-family: "Noto Sans Thai", sans-serif;
  width: 400px;

  color: #fff;
  background: ${({ disabled }) =>
    disabled ? "rgba(207, 46, 59, 0.4)" : "#cf2e3b"};
  opacity: ${({ disabled }) => (disabled ? 0.8 : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  padding: 14px 24px;

  &:focus,
  &:active,
  &:focus-visible {
    outline: none;
    box-shadow: none;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 14px 20px;
  }

  .spinner {
    width: 18px;
    height: 18px;
    border: 2px solid #fff;
    border-top: 2px solid transparent;
    border-radius: 50%;
    display: inline-block;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 768px) {
    .submit-wrap {
      width: 100%;
    }

    .submit-btn {
      width: 100%;
    }
  }

`;

const Button = ({
  loading,
  children,
  disabled,
  onClick,
  className = "",
}) => {
  return (
    <StyledButton
      disabled={disabled}
      className={className}
      onClick={onClick}
    >
      {loading ? <span className="spinner" /> : children}
    </StyledButton>
  );
};

export default Button;